import { social_auth } from "./getters"

export function SET_PARAMS({commit}, [login, clients, register, user_profile, languages, attempts, layout, social_auth, use_complete_register]) {
    commit( 'SAVE_PARAMS', [ login, clients, register, user_profile, languages, attempts, layout, social_auth, use_complete_register ] )
}

export function SET_ATTEMPTS({ commit }, [attempts]) {
    commit('SAVE_ATTEMPTS', [attempts])
}

export function SAVE_ONBOARDING({ commit }, onboarding) {
    commit('SAVE_ONBOARDING', onboarding)
}